var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"channels-tabs"},[_c('h2',[_vm._v("Выбирайте удобный для вас канал связи")]),_vm._v(" "),_c('VTabsWithAnimationMTS',_vm._l((_vm.tabList),function(tab,index){return _c('VTabMTS',{key:tab.id,attrs:{"name":tab.name,"selected":index === 0}},[_c('FaqAndSupportChannelsTabContent',{attrs:{"tab":tab.content}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }